<template>
  <div class="basket">
    <div class="basket_inner">
      <div class="basket_none">
        <div class="basket_none_inner">
          <img :src="require('@/assets/img/facebook/basket_result_ico.svg')"
               style="width: 107px !important;">
          <div class="basket_none_text">
            {{ text('screen_finish_header') }}
            <span v-html="sanitize(text('screen_finish_text'))"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_bottom_basket plr" v-if="$store.getters.thxPage.button_show">
      <a v-if="$store.getters.thxPage.button_link && $store.getters.thxPage.button_link.includes('dgsn.app')"
         @click="returnInBot"
         class="fbb_btn fbb_btn_search">
        {{ $store.getters.thxPage.button_name || text('screen_finish_button_return') }}
      </a>
      <a v-else :href="$store.getters.thxPage.button_link || $store.getters.outletSettings.bot_link" target="_top"
         class="fbb_btn fbb_btn_search">
        {{ $store.getters.thxPage.button_name || text('screen_finish_button_return') }}
      </a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Home',
    components: {},
    methods: {
      returnInBot() {
        window.location = this.$store.getters.thxPage.button_link || this.$store.getters.outletSettings.bot_link
      }
    },
  }
</script>

<style scoped>

  .basket_none {
    transform: translateZ(1px);
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    padding-bottom: 25px;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .basket_none img {
    display: block;
    width: 126px;
    margin: 0 auto;
  }

  .basket_none_text {
    text-align: center;
    margin-top: 32px;
    font-size: 20px;
    font-weight: 500;
    color: #1A1A1B;
    line-height: 120%;
  }

  .basket_none_text span {
    display: block;
    font-size: 14px;
    line-height: 18px;
    color: #999;
    font-weight: normal;
    margin-top: 11px;
  }

</style>
